import { apiGateway } from "@contexts";
import { GetBankTransactionStatusResponse } from "@interfaces/Esign";
import { useQuery } from "@tanstack/react-query";
import { millisecondsInSecond } from "date-fns";

export const useVerifyBankTransferStatus = () =>
  useQuery({
    queryKey: ["transactionStatus"],
    queryFn: () =>
      apiGateway<GetBankTransactionStatusResponse>({
        url: "/enrolment/bank-transfer-challenge/verify",
        method: "GET",
      }),
    staleTime: 2 * millisecondsInSecond,
    refetchInterval: 3 * millisecondsInSecond,
  });
